import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import CloseButton from '../buttons/close-button'
import CtaButton from '../buttons/cta-button'
import TopBar from '../bars/top-bar'
import NormalText from '../texts/normal-text'

const DropLayer = props => {
  return (
    <div
      className={classNames({
        'drop-layer': true,
        'is-open': props.isOpen,
        [props.theme]: true,
        [props.className]: props.className
      })}
    >
      <TopBar
        theme={props.barTheme}
        leftChildren={[<NormalText key={1}>{props.text}</NormalText>]}
        rightChildren={[
          <CloseButton key={1} onClick={props.onCloseButtonClick} />
        ]}
      />
      <div className='drop-content'>{props.children}</div>
      {props.hasFooter ? (
        <div className='drop-footer'>
          <CtaButton
            text='apply filters'
            hasIcon={false}
            onClick={props.onFooterButtonClick}
          />
        </div>
      ) : null}
    </div>
  )
}

DropLayer.propTypes = {
  theme: PropTypes.oneOf(['gradient-theme', 'dark-theme', 'light-theme']),
  barTheme: PropTypes.oneOf(['light-bar', 'dark-bar']),
  text: PropTypes.string,
  hasFooter: PropTypes.bool,
  isOpen: PropTypes.bool,
  onCloseButtonClick: PropTypes.func,
  onFooterButtonClick: PropTypes.func
}

export default DropLayer



// WEBPACK FOOTER //
// ./src/ui/modal/drop-layer.js